import UserImage from "@/components/utils/UserImage";
import { Person } from "@/models/crunchbase/Person";
import { Funder } from "@/types/FunderTypes";
import { Box, Typography } from "@mui/material";
import BaseFunderTemplate from "./BaseFunderTemplate";

interface Props {
  funder: Funder;
}

const PersonTemplate = (props: Props) => {
  const person = props.funder.entity as Person;
  return (
    <BaseFunderTemplate>
      <>
        <Box className="header">
          <UserImage src={person.logoUrl} company />
          <Typography>{person.name}</Typography>
        </Box>

        <Box className="content">
          <Typography className="grey-text">CB Rank (Person)</Typography>
          {person.rank}
        </Box>
      </>
    </BaseFunderTemplate>
  );
};

export default PersonTemplate;
